module.exports = __webpack_public_path__ + "img/bnr-hyakka.aabf359e.jpg";